var map = {
	"./continue_playing.png": 39,
	"./start.png": 40,
	"./victory.png": 41,
	"./victory2.png": 42,
	"./welldone.png": 43
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe ^\.\/.*$
// module id = 136
// module chunks = 0